import createCrudModule from 'vuex-crud';

export default createCrudModule({
    resource: 'users',
    customUrlFn() {
        // id will only be available when doing request to single resource, otherwise null
        // type is the actions you are dispatching: FETCH_LIST, FETCH_SINGLE, CREATE, UPDATE, REPLACE, DESTROY
        return `/api_v3/current-user/`;
    },
});